import { Skeleton } from "@/components/ui/skeleton";
import { CaptionedFigure } from "@/components/shared/CaptionedFigure";
import { PhotoMosaic } from "@/components/shared/PhotoMosaic";
import { SIZES } from "@/components/shared/Img";

/** Captions the board wrote for a content block's photos – {url: text}. */
export const blockCaptions = (c) => c?.meta?.captions || {};

/**
 * All the photos of a content block (Innhald in admin): one photo is a captioned panorama, several become a mosaic
 * with the words on each picture and a full-screen viewer. Nothing yet → a quiet skeleton while loading.
 */
export const BlockPhotos = ({ c, alt, radius = "rounded-[20px]", single = "aspect-[16/10]", className, testId = "block-photos" }) => {
  const images = c?.images || [];
  const captions = blockCaptions(c);
  if (!c) return <Skeleton className={`${single} ${radius}`} />;
  if (!images.length) return null;
  if (images.length === 1) return <CaptionedFigure src={images[0]} caption={captions[images[0]]} alt={alt || c.title || ""} width={1200} sizes={SIZES.twoThirds} imgClassName={single} radius={radius} className={className} testId={testId} />;
  return <PhotoMosaic images={images} captions={captions} alt={alt || c.title || ""} radius="rounded-[14px]" className={className} testId={testId} />;
};
